import React from 'react';

import {Group} from '@pb/kit-component-group';
import {Icon, Sizes} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';

import {errorFlatButton} from './error-flat-button.module.styl';

import type {SingleColor} from '@pb/kit-component-icon';

type Props = {
    icon: typeof SingleColor[keyof typeof SingleColor],
    label: string,
    title?: string,
    onClick: () => void,
};

export const ErrorFlatButton: React.FC<Props> = ({icon, label, onClick, title}) => (
    title ? (
        <Tooltip anchor={({anchorRef, getAnchorProps}) => (
            <div onClick={onClick} ref={anchorRef} {...getAnchorProps()}>
                <Group gap="s" className={errorFlatButton}>
                    <Icon type={icon} size={Sizes.Size_12}/>
                    <strong>{label}</strong>
                </Group>
            </div>
        )}>
            {title}
        </Tooltip>
    ) : (
        <div onClick={onClick}>
            <Group gap="s" className={errorFlatButton} alignItems="center">
                <Icon type={icon} size={Sizes.Size_12}/>
                <strong>{label}</strong>
            </Group>
        </div>
    )
);
